import VItem from './VItem'
import VItemGroup from './VItemGroup'

export {
  VItem,
  VItemGroup,
}

export default {
  $_ifrontui_subcomponents: {
    VItem,
    VItemGroup,
  },
}
